












import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class BlockContentOneColumn extends Vue {
  @Prop({ type: String })
  backgroundColor!: string;
}
